export default __webpack_public_path__ + "static/media/Elipse2.ea6a1795.svg";